
/*
 * @Description: 这个文件主要是通信用的 没有UI 样式 常驻
 * @Author: kadenwang@tencent.com
 * @Date: 2021-12-08 17:48:06
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2022-07-01 17:05:26
 */

import { useEffect } from 'react';
import { ILoginStateCode, ICheckUserInfoData, ILoginType, IUserInfo } from '../../types';
import { postMessageToParent, TOKEN_AND_USER_INFO_KEY, LoginRequest } from '../../lib';
import { getLoginCgiHost } from '@tencent/syzs-login-sdk-utils';

/**
 * accessToken 换 refreshToken
 * @returns void
 */
const refreshToken2accessToken = () => {
  const userInfoTemp = LoginRequest.getLoginInfolocalStorage();

  if (!userInfoTemp) return;

  const { token_info, userinfo } = userInfoTemp;
  const { token_expire_in, refresh_token } = token_info;
  const { login_type, user_id, open_id, register_country_code } = userinfo;

  const expiredMilliseconds = (+token_expire_in * 1000) - (+new Date());

  window.aegis.infoAll(`Token ${expiredMilliseconds} 毫秒后过期 login_type ${login_type}`);

  if (login_type === ILoginType.gg) {
    if (!refresh_token) return;
    setTimeout(() => {
      const updateToken = async () => {
        const result = await LoginRequest.request(`${getLoginCgiHost()}/v3/refresh_token`, {
          token_info,
          userinfo: {
            user_id,
            open_id,
            login_type,
            register_country_code: +register_country_code,
          },
        });

        const { status_code, data, msg } = result;

        if (status_code === 0) {
          if (data?.token_info && userInfoTemp) {
            userInfoTemp.token_info = data.token_info;
          }

          LoginRequest.setLoginInfolocalStorage(userInfoTemp);
          LoginRequest.setLoginCookie();

          await postMessageToParent('COOKIE_CHANGE', {
            userInfo: LoginRequest.getUserInfoAdapter(),
            rawInfo: userInfoTemp,
          });
        } else {
          window.aegis.report('aegisError', `refresh_token error status_code ${status_code} msg ${msg}`);
        }
      };

      void updateToken();
    }, expiredMilliseconds - (60 * 1000 * 5));
  } else if (expiredMilliseconds <= 0) {
    void LoginRequest.clearLoginCookie();
  }
};

export interface ICheckLoginCache {
  code: ILoginStateCode;
  info: null | IUserInfo;
}

class BaseLogin {
  // checkLogin 自动检测是否完毕
  private checkLoginSuccess = false;

  /**
   * 获得用户信息
   */
  public getUserInfo = (): void => {
    if (this.checkLoginSuccess) {
      const info = LoginRequest.getUserInfoAdapter();

      void postMessageToParent('CHECK_LOGIN_SUCCESS', {
        code: info ? ILoginStateCode.USER_LOGIN_SUCCESS : ILoginStateCode.USER_LOGOUT,
        info,
        rawInfo: LoginRequest.getLoginInfolocalStorage(),
      });
    } else {
      void this.checkLogin().then(() => {
        this.checkLoginSuccess = true;
      });
    }
  };

  /**
   * 校验登陆态是否失效接口
   */
  private checkLogin = async (): Promise<boolean> => {
    const userinfostr = localStorage.getItem(TOKEN_AND_USER_INFO_KEY);

    if (userinfostr) {
      const userinfoByStorge: ICheckUserInfoData = JSON.parse(userinfostr);
      const { userinfo, token_info } = userinfoByStorge;
      const { user_id, open_id, login_type, register_country_code } = userinfo;

      const result = await LoginRequest.request(`${getLoginCgiHost()}/v3/checklogin`, {
        token_info,
        userinfo: {
          user_id,
          open_id,
          login_type,
          register_country_code: +register_country_code,
        },
      });
      const { status_code, data, msg } = result;

      if (status_code === 0) {
        // 校验成功
        if (data?.token_info) {
          userinfoByStorge.token_info = data.token_info;
        }

        const userInfoTemp = userinfoByStorge;

        const mail = await LoginRequest.getUserBindEmail();

        if (mail) {
          userInfoTemp.userinfo.userBindMail = mail;
        }

        LoginRequest.setLoginInfolocalStorage(userInfoTemp);
        LoginRequest.setLoginCookie();

        await postMessageToParent('CHECK_LOGIN_SUCCESS', {
          code: ILoginStateCode.USER_LOGIN_SUCCESS,
          info: LoginRequest.getUserInfoAdapter(),
          rawInfo: LoginRequest.getLoginInfolocalStorage(),
        });

        // access_token 刷新器
        refreshToken2accessToken();

        return true;
      }

      window.aegis.infoAll('aegisInfoAll', `checklogin fail status_code ${status_code} msg ${msg}`);
      // 校验失败了
      void LoginRequest.clearLoginCookie();

      await postMessageToParent('CHECK_LOGIN_SUCCESS', {
        code: ILoginStateCode.USER_LOGOUT,
        info: null,
        rawInfo: null,
      });

      return false;
    }

    await postMessageToParent('CHECK_LOGIN_SUCCESS', {
      code: ILoginStateCode.USER_LOGOUT,
      info: null,
      rawInfo: null,
    });

    return false;
  };
}

const Login = new BaseLogin();

const IPC = () => {
  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (!event.data) return;
      const { eventType } = event.data;
      if (!eventType) return;

      switch (eventType) {
        case 'getUserInfo':
          void Login.getUserInfo();
          break;
        case 'callLogOut':
          void LoginRequest.clearLoginCookie();
          break;

        default:
          break;
      }
    });
  }, []);

  return null;
};

export default IPC;
